import React from 'react';
import { Link } from 'react-router-dom';
import useUserStore from '../../stores/useUserStore';
import { routeAllowedOnInstance } from '../../navigation/routeInstances';

const actions = [
  { to: '/fleet', label: 'Fleet List', icon: 'M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z' },
  { to: '/maintenance', label: 'Log Maintenance', icon: 'M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085' },
  { to: '/map', label: 'Fleet Map', icon: 'M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z' },
  { to: '/events', label: 'Events', icon: 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5', require: 'hasRole' },
  { to: '/orders', label: 'Orders', icon: 'M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z', require: 'hasRole' },
  { to: '/rma', label: 'RMA', icon: 'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182' },
];

const QuickActionsModule = () => {
  const user = useUserStore((state) => state.user);
  const hasRole = user?.isadmin || user?.can_admin || user?.can_operations || user?.can_manufacturing || user?.can_producer || user?.can_sales;

  // The module itself is on both instances, but Fleet Map and Events are not —
  // shortcuts to a route this deployment lacks would just bounce back here.
  const visible = actions.filter(a => {
    if (!routeAllowedOnInstance(a.to)) return false;
    if (!a.require) return true;
    if (a.require === 'hasRole') return hasRole;
    return false;
  });

  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
      {visible.map(action => (
        <Link
          key={action.to}
          to={action.to}
          className="flex flex-col items-center gap-1.5 p-3 rounded-md
                     bg-surface-container-low border border-transparent
                     hover:border-primary/30 hover:bg-surface-container
                     transition-all duration-200 group min-h-[44px]"
        >
          <svg className="w-5 h-5 text-on-surface-variant group-hover:text-primary transition-colors duration-200"
               fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d={action.icon} />
          </svg>
          <span className="text-[10px] text-on-surface-variant group-hover:text-on-surface text-center leading-tight transition-colors">
            {action.label}
          </span>
        </Link>
      ))}
    </div>
  );
};

export default QuickActionsModule;
